<div class="default-header">

    <!-- BACKGROUND-IMAGE -->
    <div class="login-img">

        <!-- GLOABAL LOADER -->
        <!-- <div id="global-loader">
				<img src="../../assets/images/svgs/loader.svg" class="loader-img" alt="Loader">
            </div> -->


            
        <div class="page">
            <div class="fix-to-center">
                <!-- CONTAINER OPEN -->
                <div class="col col-login mx-auto">
                    <div class="text-center">
                        <img  style="width:100px" src="../../assets/images/brand/astro.png" class="header-brand-img" alt="">
                    </div>
                </div>
                <div class="container-login100">
                    <div class="wrap-login100 p-6">
                        <form *ngIf="requestOtp" class="login100-form validate-form" [formGroup]="requestOtpForm" (submit)="requestOtpSubmit()">
                            <span class="login100-form-title">
                                Request OTP
                            </span>
                            <div class="wrap-input100 validate-input"
                                data-validate="Valid email is required: ex@abc.xyz">
                                <input class="input100" type="email" formControlName="email" placeholder="Email" required >
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="zmdi zmdi-email" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="container-login100-form-btn">
                                <button type="submit" class="login100-form-btn btn-primary"  [disabled]="!requestOtpForm.valid">
                                    Submit
                                </button>
                            </div>
                        </form>
                        <form *ngIf="checkOtp" class="login100-form validate-form">
                            <span class="login100-form-title">
                                Verify Mobile OTP
                            </span>
                            <div class="wrap-input100 text-center">
                                <ng-otp-input  (onInputChange)="onOtpChange($event)"  [config]="{length:4}"></ng-otp-input>
                            </div>
                            <div class="wrap-input100 text-center">
                                <button class="btn btn-link text-danger" (click)="requestOtpSubmit()">Resend OTP.</button>
                            </div>
                        </form>
                        <form *ngIf="changePassword" class="login100-form validate-form" [formGroup]="changePasswordForm" (submit)="changePasswordSubmit()">
                            <span class="login100-form-title">
                                Change Password
                            </span>
                            <div class="wrap-input100 validate-input"
                                data-validate="Valid email is required: ex@abc.xyz">
                                <input class="input100" type="password" formControlName="password" placeholder="Password" required >
                                <span class="focus-input100"></span>
                                <span class="symbol-input100">
                                    <i class="zmdi zmdi-email" aria-hidden="true"></i>
                                </span>
                            </div>
                            <div class="container-login100-form-btn">
                                <button type="submit" class="login100-form-btn btn-primary"  [disabled]="!changePasswordForm.valid">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- CONTAINER CLOSED -->
            </div>
        </div>
    </div>
    <!-- BACKGROUND-IMAGE CLOSED -->


</div>